import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import OptOutCard from "../components/OptOutCard";
import { optOutOfSms } from "../api/optOutApi";

/**
 * Public tap-to-stop page for the link inside every marketing SMS
 * (crm.collings.com.au/s/<code>). The link points at this domain to keep the text
 * short and branded, so this page has to do the work: it calls the backend opt-out
 * endpoint and shows the result. Without it the link opened a blank page, because
 * the single-page app had no route for /s/<code>.
 */
const SmsOptOutPage = () => {
  const { code } = useParams();
  const [state, setState] = useState("loading");
  const [result, setResult] = useState({ title: "", message: "" });
  const requested = useRef(false);

  useEffect(() => {
    // The effect runs twice under React StrictMode in development; the endpoint is
    // idempotent, but there's no reason to call it twice.
    if (requested.current) return;
    requested.current = true;

    let active = true;
    optOutOfSms(code)
      .then((data) => {
        if (!active) return;
        if (data.status === "redirect") {
          // Backend couldn't answer in JSON; let it serve its own page instead.
          window.location.replace(data.url);
          return;
        }
        setResult({ title: data.title, message: data.message });
        setState(data.status === "ok" ? "done" : "error");
      })
      .catch(() => {
        if (!active) return;
        setResult({
          title: "Something went wrong",
          message:
            "We couldn't process your opt-out just now. Please try again in a moment, " +
            "or reply to any email from us and we'll remove you manually.",
        });
        setState("error");
      });

    return () => {
      active = false;
    };
  }, [code]);

  return (
    <OptOutCard
      state={state}
      title={state === "loading" ? "One moment" : result.title}
      message={state === "loading" ? "Processing your request..." : result.message}
    />
  );
};

export default SmsOptOutPage;
